var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-control custom-checkbox"},[_vm._t("default"),_c('label',{staticClass:"custom-control-label",attrs:{"for":_vm.target}},[_vm._v(" "+_vm._s(_vm.caption)+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }